import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { getInvoiceData } from '../../../store/actions/store-info-actions'
import { sendOrder } from '../../../store/actions/order-actions'
import OrderUI from './UI'
import { setNestedValue } from '../../../util/helpers'
import { ORDER_DESCRIPTION, ORDER_KEY } from './constants'
import { useOnMount } from '../../../util/utility-hooks'
import { Authorities } from '../../../models/authorities'

const parseOrderAddressFromInvoiceData = ({
  address: { street, zipCode, city } = {},
}) => ({
  street,
  zipCode,
  city,
})

const InitialOrder = {
  address: { street: '', zipCode: '', city: '' },
  orderLines: {},
  message: '',
  email: '',
}

const Order = ({ user, invoiceData, forms, store, history, ...props }) => {
  const [order, setOrder] = useState(InitialOrder)
  const [valid, setValid] = useState(false)

  useOnMount(() => {
    if (user?.authorities.includes(Authorities.SETTINGS)) {
      props.getInvoiceData()
    }
  })

  useEffect(() => {
    setValid(
      [order.address.street, order.address.zipCode, order.address.city].every(
        val => !!val,
      ),
    )
  }, [order.address])

  useEffect(() => {
    setOrder({
      ...order,
      address: parseOrderAddressFromInvoiceData(invoiceData),
    })
  }, [invoiceData])

  const handleMoreFormsClick = () => {
    history.push('/support/docs')
  }

  const handleChange = (path, value) => {
    setOrder({
      ...order,
      ...setNestedValue(order, path, value),
    })
  }

  const handleSubmit = () => {
    const { address, orderLines, message, email } = order
    const requestBody = {
      deliveryAddress: {
        street: address.street,
        postalArea: address.city,
        postalCode: address.zipCode,
      },
      order: Object.entries(orderLines)
        .filter(([, quantity]) => !!quantity)
        .map(([orderKey, quantity]) => ({
          quantity,
          description:
            ORDER_DESCRIPTION[
              Object.entries(ORDER_KEY).find(
                ([, value]) => value === orderKey,
              )[0]
            ],
        })),
      comments: message,
      email,
    }
    props.sendOrder(requestBody).then(() =>
      setOrder({
        ...InitialOrder,
        address: order.address,
      }),
    )
  }

  return (
    <OrderUI
      userFullName={user.name}
      storeName={store.tradeName}
      country={store.country}
      order={order}
      valid={valid}
      onMoreFormsClick={handleMoreFormsClick}
      onChange={handleChange}
      onSubmit={handleSubmit}
    />
  )
}

Order.propTypes = {
  user: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  invoiceData: PropTypes.object.isRequired,
  sendOrder: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  user: state.auth,
  store: state.storeInfo.currentStore,
  invoiceData: state.storeInfo.invoiceData,
})

const mapDispatchToProps = dispatch => ({
  getInvoiceData: () => dispatch(getInvoiceData()),
  sendOrder: requestBody => dispatch(sendOrder(requestBody)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Order))
